// LoRaWAN US902-928 channel plan, per the LoRa Alliance Regional Parameters:
// 64 uplink channels of 125 kHz from 902.3 MHz every 200 kHz, 8 uplink
// channels of 500 kHz from 903.0 MHz every 1.6 MHz, and 8 downlink channels of
// 500 kHz from 923.3 MHz every 600 kHz.

import type { Channel, Scheme } from '../scheme.ts'

export const LORAWAN_US915_ID = 'lorawan-us915'

export function lorawanUs915Scheme(): Scheme {
  const channels: Channel[] = []
  for (let i = 0; i < 64; i++) {
    channels.push({ label: `U${i}`, centerHz: 902.3e6 + i * 200e3, widthHz: 125e3, group: 'uplink 125 kHz' })
  }
  for (let i = 0; i < 8; i++) {
    channels.push({ label: `U${64 + i}`, centerHz: 903.0e6 + i * 1.6e6, widthHz: 500e3, group: 'uplink 500 kHz' })
  }
  for (let i = 0; i < 8; i++) {
    channels.push({ label: `D${i}`, centerHz: 923.3e6 + i * 600e3, widthHz: 500e3, group: 'downlink 500 kHz' })
  }
  return {
    id: LORAWAN_US915_ID,
    name: 'LoRaWAN US915',
    source: 'LoRa Alliance RP002 Regional Parameters, US902-928',
    builtin: true,
    channels,
    bands: [],
    markers: [],
  }
}
